export default function Products(props) {
  return (
    <div className="col-lg-4 col-12 mb-lg-0 mb-4 px-4">
      <div className="text-center">
        <img src={props.image} alt="..." style={{ height: "55px" }} />
        <h5 class="mt-1">{props.title}</h5>
      </div>

      <div class="mt-2">
        <p class="text-start mb-0">{props.body}</p>
      </div>
    </div>
  );
}
